'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state) {
    this.Auth = Auth;
    this.$state = $state;
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then((user) => {
          // Logged in, redirect to home
          if (user.role === 'staff') {
            this.$state.go('appstore');
          } else if (user.role === 'customer') {
            this.$state.go('carousel');
          }
          else {
            this.$state.go('appstore');
          }
        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js